import { combineReducers } from '@reduxjs/toolkit';
import { gqBlogsFetchReducers } from './reducers/gq-blogs';

const rootReducer = combineReducers({
    ...gqBlogsFetchReducers,
});

export default rootReducer;